module.exports = __webpack_public_path__ + "img/kaimenhong.23f15f01.png";